module.exports = __webpack_public_path__ + "static/img/music.dc069b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/music.png
// module id = AMym
// module chunks = 1